import request from '@/http/request'
const entryclassify = {
  namespaced: true,
  state: {
    myMemberKeywordsTagList: []
  },
  mutations: {
    // 获取分类数据
    setMyMemberKeywordsTagList (state, val) {
      state.myMemberKeywordsTagList = val
    }
  },
  actions: {
    // 获取已有的分类 - 已移除getClassifyList接口调用
    async getMemberKeywordsTagList ({ commit }) {
      // 接口已移除，设置空数组
      commit('setMyMemberKeywordsTagList', [])
    }
  }
}

export default entryclassify
